export const checkIsFieldRequired = (fields, name, initialValue) => {
	const field = fields[name]
	if (Object.keys(fields).length === 0) return initialValue
	return (field?.key || field) === 'required'
}
